import { DataDRequest } from "../../../data/DRequest";
import { Entidad } from "../../../data/Entidad";
import { UIUtilLang } from "../../util/Language";
import { FormGenerator } from "../Formulario";
import { NotificacionV2 } from "../NotificacionV2";
import { _ModalThingsBase } from "./ModalThingsBase";
import { ModalThingsUtil as util } from "./Utils";

import CAccionPermiso = Entidad.CAccionPermiso
type IModalThings<Extras> = util.IModalThings<Extras>
type IModalThingsBase1 = util.IModalThingsBase1


export interface IModalFormConfig<T, TExtras = any> extends Pick<IModalThingsBase1, "Title" | "Modulo" | "Action" | "IdsEscuelas" | "LangModuleKeyInContext"> {
    /** @default true */
    AutoShow?: boolean
    /** Si se define "Action", por default toma la cadena del key del enum, a menos que se defina */
    AccionToHttpMessage?: string;

    GetForm: (content: TSelectionHTML<"div">, modalThings: IModalThings<TExtras>) => FormGenerator<T>;
    // Message?: string,
    /** Personaliza contenido extra despues del mensaje de confirmación y despues de dibujar el formulario */
    DrawContent?: (content: TSelectionHTML<"div">, form: FormGenerator<T>, modalThings: IModalThings<TExtras>) => void;
    /** @default 500 px */
    Width?: number;
    Height?: string;
    OnClose?: () => void;
    OnAccept?: (form: FormGenerator<T>, modalThings: IModalThings<TExtras>) => Promise<DataDRequest.IResultadoPeticion<any>>;
}

export interface IModalFormController<DataForm, TExtras = any> extends IModalThings<TExtras> {
    Form: FormGenerator<DataForm>;
}

/** Modal especial para un proceso de Formulario */
export function _ModalForm<T, TExtras = any>(config: IModalFormConfig<T, TExtras>): IModalFormController<T, TExtras> {
    const finalConf: IModalFormConfig<T, TExtras> = {
        ... <IModalFormConfig<T, TExtras>>{
            GetForm: null,
        },
        AutoShow: true,
        ...config
    }

    // >> LangModuleContext Fix
    const langContextTitle = util.GetLangContext(config.LangModuleKeyInContext, config.Title, config.Modulo, config.Action);

    // >> Verifica propiedades de cofiguración
    finalConf.AccionToHttpMessage = (finalConf.AccionToHttpMessage || CAccionPermiso[config.Action]);
    finalConf.Width = (finalConf.Width || 500);

    // >> Crea Form - instancia
    let modalForm: FormGenerator<T>;

    // Create ModalThings
    let modalT = _ModalThingsBase<TExtras>(langContextTitle.StringTag, finalConf.Width, "body_temp", undefined, config.Height, finalConf.AutoShow);

    // Append From
    if (finalConf.GetForm) {
        modalForm = finalConf.GetForm(modalT.CurrentBody, modalT);
        modalT.CurrentBody.append(() => modalForm._Form.node())
    }

    // Update content draw
    if (finalConf.DrawContent) {
        finalConf.DrawContent(modalT.CurrentBody, modalForm, modalT);
    }

    // Verificacion de permisos
    let hasPermission = util.ActionPermission(config.Action, config.Modulo, config.IdsEscuelas);

    modalT.Modal._OnClose(finalConf.OnClose);

    if (!finalConf.OnAccept || !hasPermission) {
        modalT.Modal._FooterSelection
            .remove();
    } else {
        modalT.BtnLeft.classed("hide_transparent", false);
        // else {
        //     modalT.BtnLeft.remove();
        // }

        modalT.Modal._FooterSelection
            .style("justify-content", null);

        modalT.BtnLeft
            .style("margin-right", "0px")
            .on("click", () => {
                modalT.Modal._Ocultar();
            })

        modalT.BtnRight
            .on("click", async () => {
                if (modalT.BtnRight.classed("btn_disable")) return;
                if (finalConf.OnAccept) {
                    if (modalForm._GetIsValidForm()) {
                        modalT.Modal._DeshabilitarBtns();
                        modalT.Progress.attr("oculto", false);
                        // if (finalConf.OnAccept instanceof Promise) {
                        let res = await finalConf.OnAccept(modalForm, modalT);

                        if (res) {
                            let mess = res.Mensaje || UIUtilLang._GetHTTPMessage(res, finalConf.AccionToHttpMessage) || "";
                            if (res.Resultado > 0) {
                                modalT.Modal._Ocultar();
                            } else {
                                modalT.Modal._HabilitarBtns();
                                modalT.Progress.attr("oculto", true);
                            }
                            NotificacionV2._Mostrar(mess, res.Resultado > 0 ? "INFO" : "ADVERTENCIA");
                        } else {
                            modalT.Modal._HabilitarBtns();
                            modalT.Progress.attr("oculto", true);
                        }
                    }
                }
            });
    }

    return {
        ...modalT,
        ...{
            Form: modalForm
        }
    };
}